<div class="modal-header">
  <h1 class="modal-title" id="modal-basic-title" *ngIf="contact.id < 1">
    {{ 'Add contact' | translate }}
  </h1>
  <h1 class="modal-title" id="modal-basic-title" *ngIf="contact.id > 0">
    {{ 'Update contact' | translate }}
  </h1>
</div>
<div class="modal-body">
  <div class="w-100 mt-4">
    <form
      class="d-flex align-items-center justify-content-center flex-column"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit()"
    >
      <div class="pt-4 w-100 form-group">
        <label for="firstName"
          ><strong>{{ 'First name' | translate }}</strong></label
        >
        <input
          id="firstName"
          type="text"
          formControlName="firstName"
          class="form-control"
          [placeholder]="'First name' | translate"
          class="w-100"
        />
        <div
          *ngIf="formGroup.get('firstName')?.touched &&formGroup.get('firstName')?.errors?.['required']"
          class="text-danger"
        >
          {{ 'First name' | translate }} {{ 'is required' | translate }}
        </div>
        <div
          *ngIf="formGroup.get('firstName')?.touched &&formGroup.get('firstName')?.errors?.['maxlength']"
          class="text-danger"
        >
          {{ 'First name' | translate }} {{ 'is too long' | translate }}
        </div>
      </div>
      <div class="pt-4 w-100 form-group">
        <label for="lastName"
          ><strong>{{ 'Last name' | translate }}</strong></label
        >
        <input
          id="lastName"
          type="text"
          class="form-control"
          formControlName="lastName"
          [placeholder]="'Last name' | translate"
          class="w-100"
        />
        <div
          *ngIf="formGroup.get('lastName')?.touched &&formGroup.get('lastName')?.errors?.['required']"
          class="text-danger"
        >
          {{ 'Last name' | translate }} {{ 'is required' | translate }}
        </div>
        <div
          *ngIf="formGroup.get('lastName')?.touched && formGroup.get('lastName')?.errors?.['maxlength']"
          class="text-danger"
        >
          {{ 'Last name' | translate }} {{ 'is too long' | translate }}
        </div>
      </div>
      <div class="pt-4 w-100 form-group">
        <label for="email"
          ><strong>{{ 'Email' | translate }}</strong></label
        >
        <input
          id="email"
          type="text"
          formControlName="email"
          class="form-control"
          [placeholder]="'Email' | translate"
          class="w-100"
        />
        <div
          *ngIf="formGroup.get('email')?.touched && formGroup.get('email')?.errors?.['required']"
          class="text-danger"
        >
          {{ 'Email' | translate }} {{ 'is required' | translate }}
        </div>
        <div
          *ngIf="formGroup.get('email')?.touched && formGroup.get('email')?.errors?.['maxlength']"
          class="text-danger"
        >
          {{ 'Email' | translate }} {{ 'is too long' | translate }}
        </div>
        <div *ngIf="formGroup.get('email')?.touched  &&formGroup.get('email')?.errors?.['email']" class="text-danger">
          {{ 'Email' | translate }} {{ 'is not valid' | translate }}
        </div>
      </div>

      <div class="pt-4 modal-footer justify-content-center">
        <button type="submit" class="btn btn-primary">
          {{ 'Accept' | translate }}
        </button>
        <button class="btn btn-secondary" type="button" (click)="onClose()">{{ 'Cancel' | translate }}</button>
      </div>
    </form>
  </div>
</div>
